import { render } from "./H5TicketShortLink.vue?vue&type=template&id=6af1f233&scoped=true"
import script from "./H5TicketShortLink.vue?vue&type=script&lang=js"
export * from "./H5TicketShortLink.vue?vue&type=script&lang=js"

import "./H5TicketShortLink.vue?vue&type=style&index=0&id=6af1f233&scoped=true&lang=css"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af1f233"]])

export default __exports__